<mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate">
  <input matStartDate [formControl]="range.controls.from" [placeholder]="'@startDate' | translate">
  <input matEndDate [formControl]="range.controls.to" [placeholder]="'@endDate' | translate">
</mat-date-range-input>
<mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
<mat-date-range-picker #picker (opened)="onPickerOpened()">
  <mat-date-range-picker-actions>
    <div class="preset-actions">
      <div class="preset-row">
        <button *ngFor="let preset of presets" class="preset-chip"
                [class.active]="isPresetActive(preset.days)"
                [attr.aria-pressed]="isPresetActive(preset.days)"
                (click)="applyPreset(preset.days); picker.close()">
          {{ preset.label | translate }}
        </button>
      </div>
      <div class="preset-confirm">
        <!-- Apply is required: with an actions row, Material defers calendar picks until applied. -->
        <button class="preset-chip active" matDateRangePickerApply>{{ '@apply' | translate }}</button>
      </div>
    </div>
  </mat-date-range-picker-actions>
</mat-date-range-picker>
